import { SchedulerAPI } from "../infrastructure/api/Scheduler.api";
import { IntegrationProvider, OAuthOptions } from "../domain/types";

const STATE_KEY = "scheduler.oauth.state";

/** Where the provider sends the therapist back. Must be registered with both. */
export function redirectUriFor(provider: IntegrationProvider): string {
    return `${window.location.origin}/scheduler/oauth/${provider}`;
}

/**
 * Send the therapist off to grant access.
 *
 * The `state` is kept in sessionStorage — not localStorage — so it dies with
 * the tab and cannot be replayed from another one.
 */
export async function startOAuth(
    provider: IntegrationProvider,
    options: OAuthOptions = {}
): Promise<void> {
    const redirectUri = redirectUriFor(provider);
    const { data } = await SchedulerAPI.getAuthorizeUrl(provider, redirectUri, options);

    sessionStorage.setItem(`${STATE_KEY}.${provider}`, data.state);
    window.location.assign(data.authorize_url);
}

/** True when the provider echoed back the state we sent. Consumes it either way. */
export function consumeExpectedState(
    provider: IntegrationProvider,
    received: string | null
): boolean {
    const key = `${STATE_KEY}.${provider}`;
    const expected = sessionStorage.getItem(key);
    sessionStorage.removeItem(key);
    return Boolean(expected) && expected === received;
}

export function isIntegrationProvider(
    value: string | undefined
): value is IntegrationProvider {
    return value === "zoom" || value === "google" || value === "microsoft";
}
